import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IosInstallDrawerComponent } from './ios-install-drawer.component';
import { MobileDrawerModule } from '../mobile-drawer/mobile-drawer.module';

@NgModule({
    declarations: [IosInstallDrawerComponent],
    imports: [
        CommonModule,
        MobileDrawerModule
    ],
    exports: [IosInstallDrawerComponent]
})
export class IosInstallDrawerModule { } 